import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"> </div>
      <p className="loadingText"> Loading...</p>
    </div>
  );
};

export default Loader;
